<template>
    <div id="chart">
        <apexchart type="line" height="350" :options="chartOptions" :series="series"></apexchart>
    </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import {Money} from './../../../services/Money.js';
export default {
    name: "LineMany",
    components: {
        apexchart: VueApexCharts,
    },
    props:{
        chartData:{
            type:Object
        } ,
        documents:{
            type:Array
        },
        analyzeType:{
            type:String,
        },
        analyzeLevel: {
            type: Object
        },
        currency:{
            type:String
        },
    },
    data() {
        return {
            money:new Money(),
            colors:['#008000', '#FF0000', '#0000FF', '#FFFF00', '#800000', '#FF8C00', '#800080', '#FF00FF', '#808080', '#00FFFF', '#00FF00', '#FF1493', '#DEB887', '#FFD700', '#FFC0CB', '#90EE90', '#BC8F8F', '#00BFFF', '#7B68EE', '#4682B4', '#ADFF2F', '#808000', '#008080', '#DCDCDC', '#8B4513', '#2F4F4F', '#B8860B', '#EEE8AA', '#DC143C', '#FA8072']
        }
    },
    computed: {
        series() {
           return this.generateChartData(this.documents, this.chartData.crit_1,this.chartData.crit_2);
        },
        chartOptions() {
            const objectSumColors = this.generateUniqueColors(this.generateChartData(this.documents, this.chartData.crit_1,this.chartData.crit_2).length);
            const self = this;
            return {
                chart: {
                    height: 350,
                    type: 'line',
                    zoom: {
                        enabled: false
                    },
                    defaultLocale: 'pl',
                    locales: [{
                        name: 'pl',
                        options: {
                            toolbar: {
                                exportToSVG:$.i18n._('chart_export_SVG'),
                                exportToPNG:$.i18n._('chart_export_PNG') ,
                                exportToCSV:$.i18n._('chart_export_CSV'),
                                zoomIn:$.i18n._('chart_zoom_in'),
                                zoomOut:$.i18n._('chart_zoom_out'),
                                pan:$.i18n._('chart_pan'),
                                reset:$.i18n._('chart_reset'),
                            }
                        }
                    }],
                },
                dataLabels: {
                    enabled: false
                },
                title: {
                    text: this.getTitle(),
                    align: 'left'
                },
                states: {
                    hover: {
                        filter: {
                            type: 'none' // Wyłącza przezroczystość na hover
                        }
                    }
                },
                legend: {
                    tooltipHoverFormatter: function(val, opts) {
                        return val + ' - ' + self.money.localize(opts.w.globals.series[opts.seriesIndex][opts.dataPointIndex]) + ''
                    }
                },
                markers: {
                    size: 0,
                    hover: {
                        sizeOffset: 6
                    }
                },
                xaxis: {
                    categories: this.generateChartData(this.documents, this.chartData.crit_1,this.chartData.crit_2, false)
                },
                yaxis: {
                    title: {
                        text: this.__("net_value_in_base_currency"),
                        style: {
                            fontSize: '9px',
                        },
                    },
                    forceNiceScale:true,
                    min: 0, // Minimalna wartość na osi Y
                    max: this.getMax(), // Maksymalna wartość na osi Y
                    labels: {
                        formatter: function (val) {
                            return self.money.localizeWithInt(val);
                        },
                    },
                },
                colors:this.colors,
                tooltip: {
                    y: {
                        formatter: function (value, { seriesName }) {
                            return self.money.localize(value);
                        },
                        title:{
                            formatter: function (seriesName) {
                                return self.__('net_base_currency_value').replace("base_currency", self.currency)
                            }
                        }
                    },
                    x:{
                        formatter: function (value, series) {
                            return self.generateChartData(self.documents, self.chartData.crit_1,self.chartData.crit_2, false)[value-1];
                        }
                    }
                },
                grid: {
                    borderColor: '#f1f1f1',
                }
            }
        },
    },
    methods:{
        roundToNextTen(value) {
            // Zaokrąglanie w górę do najbliższej potęgi 10
            return Math.ceil(value / 10) * 10;
        },

        formatWithZeros(value) {
            // Formatowanie wartości z zerami
            return value.toFixed(0);
        },

        getMax() {
            let max = Number.NEGATIVE_INFINITY;

            for (const obj of this.series) {
                const maxValueInSeries = Math.max(...obj.data);

                // Zaokrąglenie wartości do najbliżej większej potęgi 10
                const roundedValue = this.roundToNextTen(maxValueInSeries);

                // Formatowanie wartości z zerami
                const formattedValue = parseFloat(this.formatWithZeros(roundedValue));
                if (formattedValue > max) {
                    max = formattedValue;
                }
            }
            return parseFloat(max);
        },
        getTitle(){
            let transPart = this.chartData.crit_1;
            if(transPart == 'date_item_name' && this.analyzeLevel.date_segregation == 'year'){
                transPart = 'years';
            }
            let transPart2 = this.chartData.crit_2;
            if(transPart2 == 'date_item_name' && this.analyzeLevel.date_segregation == 'year'){
                transPart2 = 'years';
            }
            if (this.analyzeType == 'sell') {
                return this.__("analyze_sell_part") + ' ' + this.__(transPart) +  " " + this.__('and') + " " + this.__(transPart2)
            } else {
                return this.__("analyze_buy_part") + ' ' + this.__(transPart) +  " " + this.__('and') + " " + this.__(transPart2)

            }

        },
        getRandomColor() {
            const letters = '0123456789ABCDEF';
            let color = '#';
            for (let i = 0; i < 6; i++) {
                color += letters[Math.floor(Math.random() * 16)];
            }
            return color;
        },
        generateUniqueColors(count) {
            const uniqueColors = ['#33b2df'];

            while (uniqueColors.length < count) {
                // Wygeneruj nowy kolor i upewnij się, że nie istnieje w tablicy
                const newColor = this.getRandomColor();
                if (!uniqueColors.includes(newColor)) {
                    uniqueColors.push(newColor);
                }
            }

            return uniqueColors;
        },
        generateChartData(data, param2, param3, series = true) {
            let uniqueKeys = [...new Set(data.map((item) => item[param2]))];
            uniqueKeys =  uniqueKeys.filter(obj => obj !== 'REST');
            let categories = [];
            if(param3 != 'date_item_name' || (param3 == 'date_item_name' && this.analyzeLevel.date_segregation == 'year')){
                categories = [...new Set(data.map((item) => item[param3]))];
                categories =  categories.filter(obj => obj !== 'REST');
                categories.sort((a, b) => {
                    const aOrder = data.find(obj => obj[param3] === a)[param3.replace('_name', '_order')];
                    const bOrder = data.find(obj => obj[param3] === b)[param3.replace('_name', '_order')];
                    return aOrder - bOrder;
                });
            }
            else{
                const dateValues = data.map(obj => new Date(obj['date_chart']));
                const minDate = new Date(Math.min(...dateValues));
                const maxDate = new Date(Math.max(...dateValues));
                minDate.setDate(1);
                minDate.setHours(0, 0, 0, 0);
                maxDate.setHours(0, 0, 0, 0);
                // Utwórz listę miesięcy między minimalną a maksymalną datą
                const monthsBetween = [];
                let currentDate = minDate;
                while (currentDate <= maxDate) {
                    monthsBetween.push(currentDate.toLocaleString(navigator.language, {
                        year: 'numeric',
                        month: 'long'
                    }));
                    currentDate.setMonth(currentDate.getMonth() + 1);
                    currentDate.setHours(0, 0, 0, 0);
                }
                categories = monthsBetween;
            }

            const seriesData = [];
            uniqueKeys.sort((a, b) => {
                const aOrder = data.find(obj => obj[param2] === a)[param2.replace('_name', '_order')];
                const bOrder = data.find(obj => obj[param2] === b)[param2.replace('_name', '_order')];
                return aOrder - bOrder;
            });
            uniqueKeys.forEach((key) => {
                const dataSeries = categories.map((category) => {
                    const matchingItems = data.filter(
                        (item) => item[param2] === key && item[param3] === category
                    );
                    return parseFloat(matchingItems.reduce((sum, item) => sum + item.net_in_base_currency, 0));
                });

                const series = {
                    name: key,
                    data: dataSeries,
                };
                seriesData.push(series);
            });
            if(series){
                return seriesData;
            }
            if(!series){
                if(param3 != 'date_item_name'){
                    categories.sort((a, b) => {
                        const aOrder = data.find(obj => obj[param3] === a)[param3.replace('_name', '_order')];
                        const bOrder = data.find(obj => obj[param3] === b)[param3.replace('_name', '_order')];
                        return aOrder - bOrder;
                    });
                }
                return categories.filter(obj => obj !== 'REST');
            }
        },
    },
    mounted() {
        this.$nextTick(() => {
            this.$forceUpdate();
        });
    }

}
</script>

<style scoped>

</style>
